const API_BASE = 'https://api.pacificpearltraining.site';

export function createTrainingSearchSessionId() {
  return `pos-search-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function sendTrainingOptionEvent(event) {
  const payload = {
    ...event,
    createdAt: new Date().toISOString(),
  };
  const body = JSON.stringify({ event: payload });

  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      if (navigator.sendBeacon(`${API_BASE}/api/training-option-events`, blob)) {
        return;
      }
    }
  } catch (error) {
    console.warn('sendTrainingOptionEvent beacon failed:', error);
  }

  fetch(`${API_BASE}/api/training-option-events`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).catch(error => {
    console.warn('sendTrainingOptionEvent failed:', error);
  });
}
